"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorInputMessage = exports.Input = exports.Suffix = exports.InputContainer = void 0;

var tslib_1 = require("tslib");

var Gap_1 = tslib_1.__importDefault(require("../Gap"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var index_1 = require("../../styles/colors/index");

var BorderLessInput_1 = tslib_1.__importDefault(require("../BorderLessInput"));

var styles_1 = require("../../styles");

exports.InputContainer = styles_1.styledWithProps(Gap_1.default, ['errMsg'], styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 4px;\n\t\toutline: none;\n\t\tbackground: ", ";\n\t"], ["\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 4px;\n\t\toutline: none;\n\t\tbackground: ", ";\n\t"])), function (props) {
  return props.errMsg ? index_1.red[500] : index_1.gray[300];
}, index_1.white));
exports.Suffix = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\tdisplay: flex;\n\tmargin-right: 6px;\n"], ["\n\tdisplay: flex;\n\tmargin-right: 6px;\n"])));
exports.Input = styled_components_1.default(BorderLessInput_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\theight: 100%;\n"], ["\n\theight: 100%;\n"])));
exports.ErrorInputMessage = styles_1.styledWithProps('div', ['errMsgPosition'], styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n\t\ttext-align: ", ";\n\t\tcolor: ", ";\n\t"], ["\n\t\ttext-align: ", ";\n\t\tcolor: ", ";\n\t"])), function (_a) {
  var errMsgPosition = _a.errMsgPosition;
  return errMsgPosition || 'left';
}, index_1.red[500]));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;